import {colors} from '../../../DataTable/defaultSettings';


export default {
  container: {
    padding: '0 6px'
  },
  label: {
    display: 'block',
    width: '100%',
    marginBottom: '8px',
  },
  textArea: {
    background: colors.panelInput,
    border: '1px solid ' + colors.panelBorder,
    boxShadow: 'inset 0 1px 4px rgba(0,0,20,0.09)',
    padding: '5px',
    minHeight: '120px',
    display: 'block',
    width: '100%',
    maxWidth: '100%'
  },
  submit: {
    maxWidth: '120px',
    background: colors.go,
  },
  submitHov: {
    background: colors.goAlt,
  }
}
